import { render, staticRenderFns } from "./ParametrosRelatorio.vue?vue&type=template&id=14120662&"
import script from "./ParametrosRelatorio.vue?vue&type=script&lang=js&"
export * from "./ParametrosRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports